export var COLOR_FLOW_BLUE_100 = '#e1efff';
export var COLOR_GREY_600 = '#9ba6b3';
export var COLOR_TABLE_STRIPE = '#f9fcff';
export var getCellHeight = function getCellHeight(displayDensity) {
  switch (displayDensity) {
    case 'comfortable':
      return '48px;';

    case 'cozy':
      return '40px;';

    case 'compact':
      return '32px;';

    default:
      return undefined;
  }
};